import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../app/_services/authentication/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard {
  constructor(public auth: AuthenticationService, public router: Router) {}
  canActivate(): boolean {
    if (this.auth.isLoggedIn()) {
      this.router.navigate(['/entry']);
      return false;
    }
    return true;
  }
}
